import React, { useEffect, useState } from "react";
import "../login-register-forget.less";
import { lib } from "react-single-app";
import SelectRole, { ADMIN, USER } from "../select-role";
import { PLATFORM_CODE } from "./types";
import { loginSuccess } from "../../utiis/common";
import useOauth from "../../components/hook/useOauth";

export default function OauthMiddlePage(props) {
    const platformCode = PLATFORM_CODE.QyWx;
    const [isLoading, setIsLoading] = useState(true);
    const [isLogin, setIsLogin] = useState(false);
    const loginIdentity = localStorage.getItem("role");
    const { toOauth } = useOauth({
        rootPath: loginIdentity === ADMIN ? "/login-admin" : "/login",
        loginIdentity,
        platformCode,
    });
    const loginRedirectUri = lib.getParam("redirectUrl");

    useEffect(() => {
        if (loginIdentity) {
            const { platformCode, systemCode, envCode } = BUILD_CONFIG;
            lib.setConfig(
                {
                    webToken: loginIdentity === ADMIN ? "admin" : "user",
                    env: envCode,
                },
                {
                    platformCode,
                    systemCode,
                    envCode,
                },
            );
            checkLogin();
        } else {
            setIsLoading(false);
        }
    }, []);

    const checkLogin = () => {
        lib.request({
            url: "/ucenter-account/oauth/qywx/checkLogin",
            needMask: true,
            showToast: false,
            success: res => {
                const { loginSystem } = res;
                if (loginSystem) {
                    if (window.isWxWork && loginRedirectUri) {
                        res.loginSystem = loginRedirectUri;
                    }
                    loginSuccess(res);
                } else {
                    setIsLogin(false);
                    setIsLoading(false);
                    if (loginIdentity && window.isWxWork && loginIdentity !== USER) {
                        toOauth(loginIdentity, platformCode);
                    }
                }
            },
        });
    };

    return (
        <>
            {!isLogin && !isLoading && (
                <SelectRole
                    saasInfo={props.saasInfo}
                    loading={props.loading}
                    platformCode={PLATFORM_CODE.QyWx}
                />
            )}
        </>
    );
}
